module.exports = __webpack_public_path__ + "media/newstyle/images/kloobr-969e04a5457be30016762a481e6225cb.png";